import { c as _c } from "react/compiler-runtime";
import React, { useState } from 'react';
import { Modal } from '@/components/modal';
import { Trans, useTranslation } from 'react-i18next';
import Image from 'next/image';
import { Link } from '@/components/links';
import { CallMeForm } from '@/components/CallMeForm';
import { LINKS } from '@/constants/links';
import { Text } from '@/components/typography';
import { Headline } from '@/components/typography';
const retentionLink = {
  testId: 'retention',
  analyticsParam: 'retention',
  to: LINKS().retention
};
export function WithdrawalModal(t0) {
  const $ = _c(50);
  const {
    onDontCall
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = ["personalDataRequests", "core"];
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation(t1);
  const [isOpen, setIsOpen] = useState(true);
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <strong />;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== t) {
    t3 = {
      src: "/images/sections/personalDataRequests/1.png",
      text: <Trans t={t} i18nKey="leaveModal.info.1">{t2}</Trans>
    };
    $[2] = t;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <strong />;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t) {
    t5 = {
      src: "/images/sections/personalDataRequests/2.png",
      text: <Trans t={t} i18nKey="leaveModal.info.2">{t4}</Trans>
    };
    $[5] = t;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <strong />;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t) {
    t7 = {
      src: "/images/sections/personalDataRequests/3.png",
      text: <Trans t={t} i18nKey="leaveModal.info.3">{t6}</Trans>
    };
    $[8] = t;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  let t8;
  if ($[10] !== t3 || $[11] !== t5 || $[12] !== t7) {
    t8 = [t3, t5, t7];
    $[10] = t3;
    $[11] = t5;
    $[12] = t7;
    $[13] = t8;
  } else {
    t8 = $[13];
  }
  const infoItems = t8;
  let t9;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = () => setIsOpen(false);
    $[14] = t9;
  } else {
    t9 = $[14];
  }
  let t10;
  if ($[15] !== t) {
    t10 = t("leaveModal.title");
    $[15] = t;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  let t11;
  if ($[17] !== t10) {
    t11 = <Headline variant="h5" as="h2">{t10}</Headline>;
    $[17] = t10;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== infoItems || $[20] !== t) {
    t12 = infoItems.map(item => <div key={item.src} className="flex flex-row items-center gap-6 rounded-lg bg-blue-50 px-4 py-3 md:px-6 md:py-4"><div className="h-14 w-14 shrink-0"><Image src={item.src} width={56} height={56} alt={t("leaveModal.title")} /></div><Text>{item.text}</Text></div>);
    $[19] = infoItems;
    $[20] = t;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <Link {...retentionLink} />;
    $[22] = t13;
  } else {
    t13 = $[22];
  }
  let t14;
  if ($[23] !== t) {
    t14 = <Text className="mt-2" variant="p4"><Trans t={t} i18nKey="leaveModal.text.1">{t13}</Trans></Text>;
    $[23] = t;
    $[24] = t14;
  } else {
    t14 = $[24];
  }
  let t15;
  if ($[25] !== t12 || $[26] !== t14) {
    t15 = <div className="flex flex-col gap-2">{t12}{t14}</div>;
    $[25] = t12;
    $[26] = t14;
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  let t16;
  if ($[28] !== t) {
    t16 = t("leaveModal.formText.1");
    $[28] = t;
    $[29] = t16;
  } else {
    t16 = $[29];
  }
  let t17;
  if ($[30] !== t16) {
    t17 = <Text variant="p1" className="mb-4" weight="semibold">{t16}</Text>;
    $[30] = t16;
    $[31] = t17;
  } else {
    t17 = $[31];
  }
  let t18;
  if ($[32] !== onDontCall) {
    t18 = () => {
      setIsOpen(false);
      onDontCall();
    };
    $[32] = onDontCall;
    $[33] = t18;
  } else {
    t18 = $[33];
  }
  let t19;
  if ($[34] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <Link testId="informationMemorandum" analyticsParam="informationMemorandum" to={LINKS().informationMemorandum} />;
    $[34] = t19;
  } else {
    t19 = $[34];
  }
  let t20;
  if ($[35] !== t) {
    t20 = <Text className="mb-2 text-xs!" variant="p4"><Trans t={t} i18nKey="leaveModal.text.2">{t19}</Trans></Text>;
    $[35] = t;
    $[36] = t20;
  } else {
    t20 = $[36];
  }
  let t21;
  if ($[37] !== t18 || $[38] !== t20) {
    t21 = <CallMeForm phoneLabelWithoutStar={true} type="REVOLVING_LOAN_CALL_ME" onCancel={t18} infoText={t20} />;
    $[37] = t18;
    $[38] = t20;
    $[39] = t21;
  } else {
    t21 = $[39];
  }
  let t22;
  if ($[40] !== t17 || $[41] !== t21) {
    t22 = <div>{t17}{t21}</div>;
    $[40] = t17;
    $[41] = t21;
    $[42] = t22;
  } else {
    t22 = $[42];
  }
  let t23;
  if ($[43] !== t11 || $[44] !== t15 || $[45] !== t22) {
    t23 = <div className="flex flex-col gap-8 md:gap-6">{t11}{t15}{t22}</div>;
    $[43] = t11;
    $[44] = t15;
    $[45] = t22;
    $[46] = t23;
  } else {
    t23 = $[46];
  }
  let t24;
  if ($[47] !== isOpen || $[48] !== t23) {
    t24 = <Modal analyticsParam="withdrawalModal" testId="withdrawalModal" modalName="WithdrawalModal" isVisible={isOpen} className="max-w-[38.5rem]! overflow-hidden rounded-2xl p-5 pt-8 md:rounded-4xl md:p-10" onClose={t9} closeButtonClassName="hidden">{t23}</Modal>;
    $[47] = isOpen;
    $[48] = t23;
    $[49] = t24;
  } else {
    t24 = $[49];
  }
  return t24;
}